import { render, staticRenderFns } from "./case_proposal.vue?vue&type=template&id=4a304a92&scoped=true"
import script from "./case_proposal.vue?vue&type=script&lang=js"
export * from "./case_proposal.vue?vue&type=script&lang=js"
import style0 from "./case_proposal.vue?vue&type=style&index=0&id=4a304a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a304a92",
  null
  
)

export default component.exports